import styled from "styled-components";

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
`;

const InternalContainer = styled.div`
  position: relative;
  border: 0;
  padding: 24px;
  width: 600px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 16px;
  box-shadow: 0 8px 20px #1e1d2a;
  background-color: ${(props) => props.theme.color.background.primary};
  overflow: hidden;
  top: 0;
`;

const InternalMobileContainer = styled.div`
  position: relative;
  border: 0;
  box-shadow: 0 8px 20px #1e1d2a;
  background-color: ${(props) => props.theme.color.background.primary};
  overflow: hidden;
  z-index: 10;
  top: 0;
`;

const Close = styled.img`
  position: absolute;
  top: 16px;
  right: 16px;
  size: auto;
  padding: 12px;
  cursor: pointer;
  &:hover {
    cursor: pointer;
    opacity: 90%;
  }
`;

const MobileClose = styled.img`
  position: absolute;
  right: 6px;
  display: inline-block;
  size: auto;
  cursor: pointer;
  &:hover {
    cursor: pointer;
    opacity: 90%;
  }
`;

export { Container, InternalContainer, InternalMobileContainer, Close, MobileClose };
